import React, { Component } from 'react'

import { withRouter } from 'react-router-dom'

import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import { DataView, DataViewLayoutOptions } from 'primereact/dataview';
import { Tag } from 'primereact/tag';
import timegridPlugin from '@fullcalendar/timegrid';
import ptBrLocale from '@fullcalendar/core/locales/pt-br';
import interactionPlugin from '@fullcalendar/interaction';
import { Steps } from 'primereact/steps';
import { Checkbox } from 'primereact/checkbox'
import moment from "moment";
import { DataTable } from 'primereact/datatable' 
import { Column } from 'primereact/column'
import { Dialog } from 'primereact/dialog'
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputMask } from 'primereact/inputmask';
import { InputTextarea } from 'primereact/inputtextarea'
import { MultiSelect } from 'primereact/multiselect'
import { Calendar } from 'primereact/calendar'
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog'
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { uniqueId } from "lodash"
import filesize from 'filesize'

import NavBar from '../../componentes/Navbar'
import Upload from '../../componentes/Upload/Index'
import FileList from '../../componentes/FileList'
import AgendaService from '../../app/service/AgendaService'
import GrupoTrabalhoService from '../../app/service/GrupoTrabalhoService'
import UsuarioService from '../../app/service/UsuarioService'
import AtividadeService from '../../app/service/AtividadeService'
import ArquivoAtividadeService from '../../app/service/ArquivoAtividadeService'
import UsuarioGrupoTRabalhoService from '../../app/service/UsuarioGrupoTrabalhoService'
import UploadAtividadeService from '../../app/service/UploadAtividadeService'
import ProcessoService from '../../app/service/ProcessoService'
import ProcessoImportanciaService from '../../app/service/ProcessoImportanciaService'
import ArquivoPessoaService from '../../app/service/ArquivoPessoaService'
import StatusAtividadeService from '../../app/service/StatusAtividadeService'
import FaseTarefaService from '../../app/service/FaseTarefaService'
import TituloAtividadeFaseService from '../../app/service/TituloAtividadeFaseService'
import TituloAtividadeService from '../../app/service/TituloAtividadeService'
import ExecucaoCheckListService from '../../app/service/ExecucaoCheckListService'
import CheckListAtividadeService from '../../app/service/CheckListAtividadeService'
import { AuthContext } from '../../main/ProvedorAutenticacao'

import './agenda.css'


class Agenda extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      detail: '',
      grupos: [],
      gruposLista: [],
      selectGrupo: null,
      usuarios: [],
      usuariosLista: [],
      selectUsuario: null,
      status: [],
      stausLista: [],
      selectStatus: null,
      selectStatusConsulta: null,
      tipoAtividadeConsulta: null,
      agenda: [],
      agendaExibir: null,
      agendaCalendario: [],
      openSpinner: false,
      upLoadFiles: [],
      //Modais Atividade, Alterar e Cadastrar
      atividade: null,
      codigo: '',
      titulo: '',
      pontuacao: '',
      usuarioCriouAtividade: '',
      dataRegistroAtividade: '',
      descricao: '',
      selectGrupo: null,
      selectSubGrupo: null,
      processo: null,
      pesquisaProcesso: null,
      sizePesquisa: 'col-sm-12',
      escondeBotalExcluirPesquisa: {display: 'none'},
      bloqueiaGrupo: '',
      dtLimite: '',
      hora: '',
      subGrupos: [],
      gruposAtividade: [],
      tipo: null,
      dtFatal: '',
      status: '',
      grau: [],
      selectStatus: null,
      arquivos: [],
      exibirLinkAnexo: '',
      responsaveisLista: [],
      responsaveis: [],
      interessados: [],
      quantidadeResponsaveis: '',
      interessadosLista: [],
      quantidadeInteressados: '',
      selectGrupo: null,
      optionStatus: null,
      modalDescricao: false,
      historico: [],
      modalHistorico: false,
      modalConsultarHistorico: false,
      dsHistorico: '',
      modalArquivoAnexo: false,
      registroHistorico: null,
      displayArquivosAnexados: false,
      modalDescricaoArquivo: false,
      statusAtividade: [],
      dsArquivo: '',
      campoPesquisaProcesso: '',
      processoPesquisadoVisivel: '',
      processoPesquisado: '',
      //Alterar
      modalAtividadeAlterar: false,
      novoAnexo: false,
      displayProcesso: false,
      novaAtividade: false,
      responsavel: null,
      interessado: null,
      processos: [],
      iconeImportanteParaMim: '',
      iconeImportanteParaMimTitle: '',
      exibirImportanteParaMim: '',
      importanteEmpresa: '',
      titileImportanteEmpresa: '',
      exibirImportanteEmpresa: '',
      partes: '',
      mudancaDataHistorico: [],
      //Recorrência
      recorrencia: null,
      repeticao: null,
      //Fases da Atividade
      fases: [],
      fase: null,
      //Títulos da Atividade
      titulos: [],
      tituloAtividade: null,
      dias: [],
      layout: 'grid',
      //Atividades com pessoas
      pessoa: null,
      campoPessoaPesquisada: 'none',
      pessoaPesquisada: '',
      //CheckList
      checkList: [],
      activeIndex: '',
      execucaoCheckList: null,
      modalCheckList: false,
      usuarioCheckList: '',
      dataExecucaoCheckList: '',
      statusExecucao: '',
    }

    this.tiposAtividade = [
      { tipo: 'Tarefa', codigo: 'T' },
      { tipo: 'Compromisso', codigo: 'A' },
    ];

    this.recorrencia = [
      {codigo: '2', nome: '2'},
      {codigo: '3', nome: '3'},
      {codigo: '4', nome: '4'},
      {codigo: '5', nome: '5'},
      {codigo: '6', nome: '6'},
      {codigo: '7', nome: '7'},
      {codigo: '8', nome: '8'},
      {codigo: '9', nome: '9'},
      {codigo: '10', nome: '10'},
      {codigo: '11', nome: '11'},
      {codigo: '12', nome: '12'},
      {codigo: '13', nome: '13'},
      {codigo: '14', nome: '14'},
      {codigo: '15', nome: '15'},
      {codigo: '16', nome: '16'},
      {codigo: '17', nome: '17'},
      {codigo: '18', nome: '18'},
      {codigo: '19', nome: '19'},
      {codigo: '20', nome: '20'},
      {codigo: '21', nome: '21'},
      {codigo: '22', nome: '22'},
      {codigo: '23', nome: '23'},
      {codigo: '24', nome: '24'}
    ];

    this.agendaService = new AgendaService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.usuarioService = new UsuarioService();
    this.atividadeService = new AtividadeService();
    this.grupoTrabalhoService = new GrupoTrabalhoService();
    this.arquivoAtividadeService = new ArquivoAtividadeService();
    this.usuarioGrupoTrabalhoService = new UsuarioGrupoTRabalhoService();
    this.uploadAtividadeService = new UploadAtividadeService();
    this.processoService = new ProcessoService();
    this.arquivoPessoaService = new ArquivoPessoaService();
    this.statusAtividadeService = new StatusAtividadeService();
    this.processoImportanciaService = new ProcessoImportanciaService();
    this.faseTarefaService = new FaseTarefaService();
    this.tituloAtividadeFaseService = new TituloAtividadeFaseService();
    this.tituloAtividadeService = new TituloAtividadeService();
    this.execucaoCheckListService = new ExecucaoCheckListService();
    this.checkListAtividadeService = new CheckListAtividadeService();

    this.renderFooterAtividadeAlterar = this.renderFooterAtividadeAlterar.bind(this);
    this.onGrupoTrabalhoChange = this.onGrupoTrabalhoChange.bind(this);
    this.onSubGrupoChange = this.onSubGrupoChange.bind(this);
    this.onChangeStatusAtividade = this.onChangeStatusAtividade.bind(this);
    this.acoesHistorico = this.acoesHistorico.bind(this);
    this.acceptExcluirHistorico = this.acceptExcluirHistorico.bind(this);
    this.acoesHistoricoUsuario = this.acoesHistoricoUsuario.bind(this);
    this.acoesArquivos = this.acoesArquivos.bind(this);
    this.acceptExcluirArquivo = this.acceptExcluirArquivo.bind(this);
    this.acoesProcesso = this.acoesProcesso.bind(this); 
    this.onMudancaData = this.onMudancaData.bind(this);
    this.onChangeCheckList = this.onChangeCheckList.bind(this);
    this.onGrauChange = this.onGrauChange.bind(this);

    this.tiposAtividade = [
      {codigo: 'A', nome: 'Compromissos/Audiências'},
      {codigo: 'T', nome: 'Prazos'}
    ]
  }

  onGrauChange(e) {
    let selectedGrau = [...this.state.grau];

    if (e.checked)
      selectedGrau.push(e.value);
    else
      selectedGrau.splice(selectedGrau.indexOf(e.value), 1);

    this.setState({ grau: selectedGrau });
  }

  templateCriacaoAtividade = () => {
    return(
      <div>Atividade criada por:&nbsp;&nbsp;<strong style={{color: '#3B82F6'}}>{this.state.usuarioCriouAtividade}&nbsp; em:&nbsp;{this.state.dataRegistroAtividade}</strong></div>
    );
  }

  listarFases = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.faseTarefaService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({fases: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Fases da Atividade', life: 4000});
      })
  }

  listarFasesPorTitulo = async (titulo) => {
    await this.tituloAtividadeFaseService.listar(titulo.codigo)
      .then(response => {
        this.setState({fases: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Fases da Atividade por título', life: 4000});
      })
  }

  listarTitulosAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.tituloAtividadeService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({titulos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Títulos de Atividades', life: 4000});
      })
  }

  onChangeCheckList(e) {
    if(e.value != null) {
      this.itens = [];
      this.setState({tituloAtividade: e.value});
      this.consultarCheckList(e.value.codigo);
    } else {
      this.setState({tituloAtividade: null});
      this.itens = [];
    }
  }

  consultarCheckList = async (atividade) => {
    this.setState({openSpinner: true});
    await this.checkListAtividadeService.listar(atividade)
      .then(response => {
        this.setState({checkList: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Checklista de Tarefas', detail:`${this.state.detail}`, life: 4000});
      });
      let item = null;
      for(let i = 0; i < this.state.checkList.length; i++) {
        item = {
          label: this.state.checkList[i].tarefa
        }
        this.itens.push(item);
      }
      this.setState({openSpinner: false});
  }

  listarStatusAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.statusAtividadeService.listarStatus(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({statusAtividade: response.data});
        this.setState({selectStatusConsulta: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Status Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarGruposTrabalho = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.grupoTrabalhoService.listarGruposUsuario2(usuarioLogado.codigo)
      .then(response => {
        this.setState({gruposLista: response.data});
        this.setState({grupos: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Agenda de Comprmissos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarUsuarios = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.perfil.codigo != 1) {
      const usuarios = [
        {codigo: usuarioLogado.codigo, nome: usuarioLogado.nome}
      ];
      this.setState({usuarios: usuarios});
      this.setState({usuariosLista: usuarios}); 
    } else {
      await this.usuarioService.listarUsuariosEmpresa(usuarioLogado.empresa.codigo)
        .then(response => {
          this.setState({usuarios: response.data});
          this.setState({usuariosLista: response.data});
        }).catch(error => {
          this.setState(error.response.data)
          this.toast.show({severity:'error', summary: 'Agenda de Comprmissos', detail:`${this.state.detail}`, life: 4000});
        })
      }
  }

  async componentDidMount() {
     this.setState({openSpinner: true});
     //await this.listarDias(12,2022);
     await this.listarGruposTrabalho();
     await this.listarUsuarios();
     await this.listarStatusAtividade();
     const tipos = [
       {codigo: 'A', nome: 'Compromissos/Audiências'},
       {codigo: 'T', nome: 'Prazos'}
     ];
     this.setState({tipoAtividadeConsulta: tipos});
     await this.listarAgenda();
     this.setState({openSpinner: false});
  }

  listarAgenda = async () => {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado

    var contador = 0;

    var tamanhoLista = this.state.gruposLista.length;
    let codigoGrupos = '';
    for(let i = 0; i < this.state.gruposLista.length; i++) {
      if(contador < tamanhoLista -1) {
        codigoGrupos = codigoGrupos + this.state.gruposLista[i].codigo + ",";
      } else {
        codigoGrupos = codigoGrupos + this.state.gruposLista[i].codigo;
      }

      contador++;
    }

    contador = 0;
    tamanhoLista = this.state.usuariosLista.length;
    let codigosUsuarios = 0;
    if(usuarioLogado.perfil.codigo != 1) {
      codigosUsuarios = usuarioLogado.codigo;
    } else {
      for(let i = 0; i < this.state.usuariosLista.length; i++) {
        if(contador < tamanhoLista -1) {
          codigosUsuarios = codigosUsuarios + this.state.usuariosLista[i].codigo + ",";
        } else {
          codigosUsuarios = codigosUsuarios + this.state.usuariosLista[i].codigo;
        }

        contador++;
      }
    }

    contador = 0;
    tamanhoLista = this.state.selectStatusConsulta.length;
    let codigosStatus = 0;
    for(let i = 0; i < this.state.selectStatusConsulta.length; i++) {
      if(contador < tamanhoLista -1) {
        codigosStatus = codigosStatus + this.state.selectStatusConsulta[i].codigo + ",";
      } else {
        codigosStatus = codigosStatus + this.state.selectStatusConsulta[i].codigo;
      }

      contador++;
    }

    contador = 0;
    tamanhoLista = this.state.tipoAtividadeConsulta.length;
    let codigoTipos = '';
    for(let i = 0; i < this.state.tipoAtividadeConsulta.length; i++) {
      if(contador < tamanhoLista -1) {
        codigoTipos = codigoTipos + "'" + this.state.tipoAtividadeConsulta[i].codigo + "',";
      } else {
        codigoTipos = codigoTipos + "'" + this.state.tipoAtividadeConsulta[i].codigo + "'";
      }

      contador++;
    }

    const filtro = {
      usuario: usuarioLogado.codigo,
      usuarios: codigosUsuarios,
      grupos: codigoGrupos,
      status: codigosStatus,
      tipos: codigoTipos
    }
    await this.agendaService.consultarAgenda(filtro)
      .then(response => {
        console.log('Está demorando mesmo para chegar aqui ', response.data);
        this.setState({agenda: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${error}`, life: 4000});
      })
      this.setState({openSpinner: false});
  }

  testandoClick = (rowData) => {
    console.log('Testando');
    console.log(rowData.event.title)
  }

  abrirAtividade = (rowData) => {
    this.consultarAtividadeCustom(rowData.event.id);
  }

  novaAtividade_ = async (rowdata) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
    //Seta a data do calendário
    this.setState({dtLimite: rowdata.date});
    this.setState({campoPesquisaProcesso: 'block'});
    this.setState({processoPesquisado: ''});
    this.setState({processoPesquisadoVisivel: 'none'});
    this.setState({pesquisaProcesso: ''});
    if(usuarioLogado.empresa.tituloPredefinido == 'N') {
      await this.listarFases();
    } else {
      this.setState({fases: null});
      await this.listarTitulosAtividade();
      this.setState({tituloAtividade: null});
    }
    await this.abrirNovaAtividade('novaAtividade');
    this.setState({openSpinner: false});
  }

  novaAtividade = async (rowdata) => {
    this.setState({dtLimite: rowdata.date});
    this.setState({desabilitaBotao: false});
    this.setState({escondeBotalExcluirPesquisa: {
      display: 'none'
    }});
    this.setState({campoPesquisaProcesso: 'block'});
    this.itens = [];
    this.setState({processoPesquisadoVisivel: 'none'});
    this.setState({campoPesquisaPessoa: 'block'});
    this.setState({pessoaPesquisadoVisivel: 'none'});
    this.setState({sizePesquisa: 'col-sm-12'});
    this.setState({processoPesquisado: ''});
    this.setState({pesquisaProcesso: ''});
    this.setState({bloqueiaGrupo: false});
    this.setState({openSpinner: true});
    await this.consultarGruposTrabalho();
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({tituloAtividade: null});
    this.listarTitulos();
    //this.listarTitulosAtividade();
    this.setState({subGrupos: null});
    await this.limparCamposAtividade();
    await this.excluirArquivos();
    this.setState({openSpinner: false});
    this.abrirNovaAtividadeCustom('novaAtividade')
  }

  listarTitulos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.tituloAtividadeService.listar(usuarioLogado.empresa.codigo)
      .then(response => {
        this.setState({titulos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar Títulos de Atividades', life: 4000});
      })
  }

  excluirArquivos = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.arquivoAtividadeService.excluirArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        console.log('Arquivos excluídos com sucesso');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async abrirNovaAtividadeCustom(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  consultarProcessoPorIndice = async() => {
    
    const usuarioLogado = this.context.usuarioAutenticado;
    const indice = {
      indice: this.state.pesquisaProcesso,
      empresa: usuarioLogado.empresa.codigo,
      usuario: usuarioLogado.codigo
    }

    this.setState({openSpinner: true});
    await this.processoService.consultarProcessoPorIndice(indice)
      .then(response => {
        this.setState({processos: response.data});
        if(response.data.length > 0) {
          this.abrirModalProcesso('displayProcesso');
        } else {
          this.setState({pesquisaProcesso: ''});
          this.toast.show({severity:'error', summary: 'Processos', detail:'Processo não encontrado', life: 4000});
        }
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });

      this.setState({openSpinner: false});
  }

  excluirPesquisaProcesso = () => {
    this.setState({processo: null});
    this.setState({pesquisaProcesso: ''});
    this.setState({campoPesquisaProcesso: 'block'});
    this.setState({processoPesquisado: ''});
    this.setState({processoPesquisadoVisivel: 'none'});
    this.setState({escondeBotalExcluirPesquisa: {
      display: 'none'
    }});
    this.setState({sizePesquisa: 'col-sm-12'});
    this.setState({bloqueiaGrupo: false});
    this.setState({selectGrupo: null});
    this.setState({subGrupos: null});
    this.setState({selectSubGrupo: null});
    this.setState({interessado: null});
    this.setState({responsavel: null});
   // this.setState({responsaveis: []});
  }

  abrirModalProcesso(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  renderFooterProcesso(name) {
    return (
        <div className="left">
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  acoesProcesso(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-check" className="p-button-rounded p-button-text" 
                tooltip="Selecionar"
                onClick={() => this.selecionarProcesso(rowData)}
                tooltipOptions={{position: 'top'}} />
      </React.Fragment>
    );
  }

  async selecionarProcesso(processo) {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.processoService.consultarProcessoPorCodigo(processo.codigo, usuarioLogado.codigo)
      .then(response => {
        this.setState({processo: response.data});
        this.setState({pesquisaProcesso: processo.nrCnj});
        this.setState({selectGrupo: response.data.grupoTrabalho});
        this.setState({exibirComponentesGrupos: 'block'})
        this.setState({bloqueiaGrupo: true});
        this.setState({campoPesquisaProcesso: 'none'});
        this.setState({processoPesquisadoVisivel: 'block'});
        if(response.data.nrCnj != '' && response.data.nrCnj != null) {
          var cnjMascarado = response.data.nrCnj.substring(0, 7);
              cnjMascarado = cnjMascarado + "-" + response.data.nrCnj.substring(7, 9);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(9, 13);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(13, 14);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(14, 16);
              cnjMascarado = cnjMascarado + "." + response.data.nrCnj.substring(16, 20);
          if(response.data.fase != null) {
            this.setState({processoPesquisado: cnjMascarado + ' - ' + response.data.fase.nome});
          } else {
            this.setState({processoPesquisado: cnjMascarado});
          }
        } else {
          if(response.data.fase != null) {
            this.setState({processoPesquisado: response.data.nrProcesso + ' - ' + response.data.fase.nome});
          } else {
            this.setState({processoPesquisado: response.data.nrProcesso});
          }
        }
        //this.setState({sizePesquisa: 'col-sm-12'});
        this.setState({escondeBotalExcluirPesquisa: {
          display: 'block'
        }});
        this.consultarSubGrupos(response.data.grupoTrabalho.codigo);
        this.listarResponsaveisAtivos();
        this.listarInteressadosAtivos();
        if(response.data.fase != null) {
          this.listarTitulosPorFase(response.data.fase.codigo);
        }
        this.fecharModalAtividade('displayProcesso');
      }).catch(error => {
        this.setState(error.response.data);
        this.setState({openSpinner: false})
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  listarResponsaveisAtivos = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividadeAtivos(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responśaveis', life: 4000});
      })
  }

  listarInteressadosAtivos = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividadeAtivos(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({interessados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar interssados', life: 4000});
      })
  }

  renderFooterAtividade(name) {
    return (
        <div className="left">
            <Button label="Cadastrar" 
                    className="p-button-primary p-button-text"
                    onClick={this.cadastrarAtividade}/>
            &nbsp;
            <Button label="Anexar" 
                    icon="pi pi-paperclip"
                    onClick={() => this.abrirModalAnexo('novoAnexo')}
                    className="p-button-help p-button-text"/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  renderFooterNovoAnexo(name) {
    return (
        <div className="left">
            <Button label="Fechar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  async abrirModalAnexo(name, position) {
    await this.excluirArquivoTemp();
    await this.listarArquivosTemp();
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  excluirArquivoTemp = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.arquivoPessoaService.listarArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        this.setState({arquivos: response.data});
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });

      for(let i = 0; i < this.state.arquivos.length; i++) {
        this.arquivoPessoaService.excluirArquivoTemp(this.state.arquivos[i].codigo)
          .then(response => {
            console.log('Arquivo temporário excluído com sucesso');
          }).catch(error => {
            this.setState(error.response.data)
            this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
          })
      }
  }

  cadastrarAtividade_ = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
      if(this.state.tituloAtividade == null) {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
        return false;
      }
    } else {
      if(this.state.titulo == '') {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
        return false;
      }
    }

    if(this.state.selectGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.selectSubGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.responsavel == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    //Data Limite
    var tipoTarefa = '';
    var dataFormatadaDataLimite = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
        tipoTarefa = 'A'
      } else {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day;
        tipoTarefa = 'T';
      }
    }

    var dataFormatadaDataFatal = null;
    if(this.state.dtFatal != '' && this.state.dtFatal != null) {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
      } else {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day;
      }
    }

    var responsaveis = [];
    for(let i = 0; i < this.state.responsavel.length; i++) {
      responsaveis.push(this.state.responsavel[i]);
    }

    var interessados = [];
    if(this.state.interessado != null) {
      for(let i = 0; i < this.state.interessado.length; i++) {
        interessados.push(this.state.interessado[i]);   
      }
    }

    var recorrencia = null;;
    if(this.state.recorrencia == null) {
      recorrencia = '0';
    } else {
      recorrencia = this.state.recorrencia.codigo;
    }

    const atividadeCadastro = {
      atividade: {
        titulo: this.state.titulo,
        processo: {
          codigo: this.state.processo.codigo
        },
        subGrupo: this.state.selectSubGrupo,
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        tipo: tipoTarefa,
        status: {
          codigo: 1
        },// Ativo
        fase: this.state.fase
      },
      recorrencia: recorrencia,
      responsaveis: responsaveis,
      interessados: interessados
    }
    
    this.setState({openSpinner: true}); 
    await this.atividadeService.cadastrarAtividade(atividadeCadastro)
      .then(response => {
        this.fecharModalAtividade('novaAtividade');
        this.listarAgenda();
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade cadastrada com sucesso', life: 4000});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${error}`, life: 4000});
      })

    this.setState({openSpinner: false});
  }

  cadastrarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
      if(this.state.tituloAtividade == null) {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
        return false;
      }
    } else {
      if(this.state.titulo == '') {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
        return false;
      }
    }

    if(this.state.selectGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.selectSubGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.responsavel == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    //Data Limite
    var tipoTarefa = '';
    var dataFormatadaDataLimite = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
        tipoTarefa = 'A'
      } else {
        dataFormatadaDataLimite =  year+"-"+month+"-"+day;
        tipoTarefa = 'T';
      }
    }

    var dataFormatadaDataFatal = '';
    if(this.state.dtFatal != '' && this.state.dtFatal != null) {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '') {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+" "+this.state.hora+":00";
      } else {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day;
      }
    }

    //Responsaveis
    var responsaveis = [];
    for(let i = 0; i < this.state.responsavel.length; i++) {
      responsaveis.push(this.state.responsavel[i]);
    }

    //Interessados
    var interessados = [];
    if(this.state.interessado != null) {
      for(let i = 0; i < this.state.interessado.length; i++) {
        interessados.push(this.state.interessado[i]);
      }
    } else {
      interessados = null;
    }

    var titulo = '';
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
      titulo = this.state.tituloAtividade.titulo;
    } else {
      titulo = this.state.titulo;
    }

    var recorrencia = null;;
    if(this.state.recorrencia == null) {
      recorrencia = '0';
    } else {
      recorrencia = this.state.recorrencia.codigo;
    }

    var processo = null;
    if(this.state.processo != null) {
      processo = {
        codigo: this.state.processo.codigo
      }
    }

    var importante = 'N';
    var urgente = 'N';
    var privado = 'N';

    if(this.state.grau != null) {
      for(let i = 0; i < this.state.grau.length; i++) {
        if(this.state.grau[i] == 'importante') {
          importante = 'S';
        }

        if(this.state.grau[i] == 'urgente') {
          urgente = 'S';
        }

        if(this.state.grau[i] == 'privado') {
          privado = 'S';
        }
      }
    }

    const cadastroAtividade = {
      atividade: {
        titulo: titulo,
        processo: processo,
        subGrupo: this.state.selectSubGrupo,
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        tipo: tipoTarefa,
        //configuracaoTarefa: this.state.configuracaoTarefa,
        status: {
          codigo: 1
        }, // Ativo
        fase: this.state.fase,
        importante: importante,
        urgente: urgente,
        privado: privado,
        pessoa: this.state.pessoa,
        tituloAtividade: this.state.tituloAtividade,
        lancamentoFinanceiro: null
      },
      responsaveis: this.state.responsavel,
      interessados: this.state.interessado,
      recorrencia: recorrencia,
      responsaveisSubTarefas: null,
      interessadosSubTarefas: null
    }
    this.setState({desabilitaBotao: true});
    this.setState({openSpinner: true});
    await this.atividadeService.cadastrarAtividade(cadastroAtividade).
      then(response => {
        this.fecharModalAtividade('novaAtividade');
        this.listarAgenda();
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade cadastrada com sucesso', life: 4000});
    }).catch(error => {
      this.setState({openSpinner: false});
      this.setState(error.response.data)
      this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
    this.setState({openSpinner: false});
    this.setState({desabilitaBotao: false});
  }

  incluirResponsaveis = async (atividade) => {
    if(atividade == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Nenhuma atividade foi informada no cadastro de responsáveis', life: 4000});
      return false;
    }

    if(this.state.responsavel == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Nenhum responsável foi informado', life: 4000});
      return false;
    }

    for(let i = 0; i < this.state.responsavel.length; i++) {
     await this.atividadeService.cadastrarAtividadeUsuario({
        atividade: atividade,
        usuario: this.state.responsavel[i],
        tipo: 'R'
      }).then(response => {
        if(this.state.interessado != null) {
          this.incluirInteressados(atividade);
        }
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao cadastrar Responsáveis', life: 4000});
      })
    };

    await this.listarAgenda();
    //this.refreshPage();
  }

  incluirInteressados = async (atividade) => {
    if(atividade == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Nenhuma atividade foi informada no cadastro de responsáveis', life: 4000});
      return false;
    }

    for(let i = 0; i < this.state.interessado.length; i++) {
     await this.atividadeService.cadastrarAtividadeUsuario({
        atividade: atividade,
        usuario: this.state.interessado[i],
        tipo: 'I'
      }).then(response => {
        console.log('Interssados: ', this.state.interessado[i].nome);
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao cadastrar Interssados', life: 4000});
      })
    };
  }

  async abrirNovaAtividade(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
    this.setState({escondeBotalExcluirPesquisa: {
      display: 'none'
    }});
    await this.consultarGruposTrabalho();
    this.setState({subGrupos: null});
    await this.limparCamposAtividade();
    this.setState({arquivos: null});
  }

  limparCamposAtividade = () => {
    this.setState({processo: null});
    this.setState({titulo: ''});
    this.setState({hora: ''});
    this.setState({descricao: ''});
    this.setState({dtFatal: ''});
    this.setState({status: ''});
    this.setState({responsavel: null});
    this.setState({interessado: null});
    this.setState({responsaveis: []});
    this.setState({selectGrupo: null});
    this.setState({selectSubGrupo: null});
    this.setState({pesquisaProcesso: ''});
    this.setState({sizePesquisa: 'col-sm-12'});
    this.setState({bloqueiaGrupo: false});
        this.setState({escondeBotalExcluirPesquisa: {
          display: 'none'
        }});
  }

  testandoData = (rowData) => {
    console.log(rowData.date);
  }

  consultarGrupoTrabalhoPai = async (codigo) => {
    await this.grupoTrabalhoService.consultarGrupo(codigo)
      .then(response => {
        this.setState({selectGrupo: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao consultar Grupo de Trabalho', life: 4000});
      })
  }

  consultarSubGrupos = async(codigo) => {
    await this.grupoTrabalhoService.listarSubGrupos(codigo)
      .then(response => {
        this.setState({subGrupos: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Sub-Grupos de Trabalho', life: 4000});
      })
  }

  consultarGruposTrabalho = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.grupoTrabalhoService.listarGruposUsuario2(usuarioLogado.codigo)
      .then(response => {
        this.setState({gruposAtividade: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao carregar Grupos de Trabalhos do usuário', life: 4000});
      })
  }

  listarArquivosAtividade = async () => {
    await this.arquivoAtividadeService.listarArquivos(this.state.atividade.codigo)
      .then(response => {
        this.setState({arquivos: response.data});
        if(response.data.length > 0) {
          this.setState({exibirLinkAnexo: 'block'});
        } else {
          this.setState({exibirLinkAnexo: 'none'});
        }
      }).catch(error => {
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  consultarResponsaveis = async () => {
    await this.atividadeService.consultarUsuariosAtividade(this.state.codigo, 'R')
      .then(response => {
        this.setState({responsaveisLista: response.data});
        this.setState({quantidadeResponsaveis: 'Responsaveis da Atividade ( ' + this.state.responsaveisLista.length + ' )'});
        this.listarResponsaveis(); 
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responsáveis da atividade', life: 4000});
      })
  }

  consultarInteressados = async () => {
    await this.atividadeService.consultarUsuariosAtividade(this.state.codigo, 'I')
      .then(response => {
        this.setState({interessadosLista: response.data});
        if(this.state.interessadosLista.length == 0) {
          this.setState({quantidadeInteressados: 'Atividade sem interessados'});
        } else {
          this.setState({quantidadeInteressados: 'Interessados da Atividade ( ' + this.state.interessadosLista.length + ' )'});
        }
        this.listarInteressados();
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responsáveis da atividade', life: 4000});
      })
  }

  abrirModalAtividadeAlterar(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
    this.consultarGruposTrabalho();
  }

  abrirModalDescricao(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  fecharModalAtividade(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  listarHistorico = async () => {
    await this.atividadeService.consultarHistorico(this.state.codigo)
      .then(response => {
        this.setState({historico: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    })
  }

  consultarHistorico = async () => {
    this.setState({openSpinner: true});
    await this.atividadeService.consultarHistorico(this.state.codigo)
      .then(response => {
        this.setState({historico: response.data});
        this.abrirModalHistorico('modalConsultarHistorico');
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });
      this.setState({openSpinner: false});
  }

  acoesHistorico(rowData) {
    if(rowData.tpHistorico != 'A') {
      return (
        <React.Fragment>
           <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                   tooltip="Excluir Histórico"
                   onClick={() => this.confirmaExclusaoHistorico(rowData)}
                   tooltipOptions={{position: 'top'}}
                   style={{width: '20px', height: '10px'}}/>
        </React.Fragment>
      )
    }
  } 

  acoesHistoricoUsuario(rowData) {
    if(rowData.tpHistorico == 'A') {
      return (
        <React.Fragment>
          <i className="fa fa-solid fa-robot" title="Incluído de forma automática"/>
        </React.Fragment>
      )
    } else {
      return (
        <React.Fragment>
          <i className="pi pi-user-plus" title="Incluído manualmente"/>
        </React.Fragment>
      )
    }
  }

  confirmaExclusaoHistorico(historico) {
    this.setState({registroHistorico: historico});
    confirmDialog({
        message: 'Deseja realmente excluir o Histórico da Atividade?',
        header: 'Exclusão de Histórico de Atividades',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirHistorico,
        reject: this.reject
    });
  }

  acceptExcluirHistorico() {
    this.excluirHistorico();
  }

  excluirHistorico = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.atividadeService.excluirHistorico(this.state.registroHistorico.codigo, this.state.registroHistorico.usuario.codigo, usuarioLogado.codigo)
      .then(response => {
        this.listarHistorico();
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Histórico excluído', life: 4000});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      })
  }

  abrirModalHistorico(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  novoHistorico = () => {
    this.setState({dsHistorico: ''});
    this.abrirModalHistorico('modalHistorico');
  }

  async incluirHistorico () {
    const usuarioLogado = this.context.usuarioAutenticado

    if(this.state.dsHistorico == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o histórico da Atividade', life: 4000});
      return false;
    }

    let tipoHistorico = 'M';
    if(usuarioLogado.empresa.codigo == 138) {
      let data = 'N';
        if(this.state.mudancaDataHistorico != null & this.state.mudancaDataHistorico.length > 0) {
          for(let i = 0; i < this.state.mudancaDataHistorico.length; i++) {
            if(this.state.mudancaDataHistorico[i] == 'mudancaData') {
              data = 'S'
            }
          }
        }

        if(data == 'S') {
          tipoHistorico = 'D';
        } else {
          tipoHistorico = 'M';
        }
    } else {
      tipoHistorico = 'M';
    }

    this.setState({openSpinner: true});
    await this.atividadeService.incluirHistorico({
      atividade: {
        codigo: this.state.atividade.codigo
      },
      dsHistorico: this.state.dsHistorico,
      usuario: usuarioLogado,
      tpHistorico: tipoHistorico
    }).then(response => {
      this.listarHistorico();
      this.fecharModalAtividade('modalHistorico');
      this.toast.show({severity:'success', summary: 'Atividades', detail:'Histórico incluído com sucesso', life: 4000});
      this.setState({openSpinner: false});
    }).catch(error => {
      this.toast.show({severity:'error', summary: 'Histórico de Atividade', detail:`${error}`, life: 4000});
    })
  }

  async abrirModalArquivosAnexos(name, position){
    this.setState({openSpinner: true});
    await this.listarArquivosAtividade()
    let state = {
      [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
    this.setState({openSpinner: false});
  }

  renderFooterAtividadeAlterar(name) {
    return (
        <div className="left">
            <Button label="Alterar" 
                    onClick={this.alterarAtividadeCustom}
                    className="p-button-primary p-button-text"/>
            &nbsp;
            <Button label="Anexar" 
                    icon="pi pi-paperclip"
                    onClick={() => this.abrirModalArquivosAnexos('displayArquivosAnexados')}
                    className="p-button-help p-button-text"/>
            &nbsp;
            <Button label="Histórico" 
                    icon="pi pi-history"
                    className="p-button-help p-button-text"
                    onClick={this.consultarHistorico}/>
            &nbsp;
            <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalAtividade(name)}/>
        </div>
    );
  }

  consultarProcessoImportancia = async (processo) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const filtro = {
      usuario: usuarioLogado.codigo,
      processo: processo
    }

    await this.processoImportanciaService.consultarProcessoImportancia(filtro)
      .then(response => {
        if(response.data != '') {
          this.setState({iconeImportanteParaMim: 'p-button-rounded p-button-danger'});
          this.setState({iconeImportanteParaMimTitle: 'Processo classificado como meus favoritos'});
          this.setState({exibirImportanteParaMim: 'hide'});
        } else {
          this.setState({iconeImportanteParaMim: 'p-button-rounded p-button-secondary'});
          this.setState({iconeImportanteParaMimTitle: 'Clique para favoritar o processo'});
          this.setState({exibirImportanteParaMim: 'none'});
        }
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Processo Importancia', detail:`${this.state.detail}`, life: 4000});
      })
  }

  async consultarAtividadeCustom(atividade) {
    this.setState({openSpinner: true});
    const usuarioLogado = this.context.usuarioAutenticado;
    await this.atividadeService.consultarAtividadeCustom(atividade,usuarioLogado.empresa.codigo,usuarioLogado.codigo)
      .then(response => {
        this.setState({atividade: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({codigoProcesso: response.data.codigoProcesso});
        this.setState({titulo: response.data.titulo});
        this.setState({pontuacao: response.data.pontos + " pontos"});
        this.setState({usuarioCriouAtividade: response.data.usuarioCriou});
        this.setState({dataRegistroAtividade: response.data.dataCriacao});
        this.setState({descricao: response.data.descricao});
        this.setState({grupoTrabalhoDescricao: response.data.grupo});
        this.setState({subGrupoTrabalhoDescricao: response.data.subGrupo});
        this.setState({codigoSubGrupo: response.data.codigoSubGrupo});
        this.setState({codigoGrupo: response.data.codigoGrupo});
        if(response.data.pessoa != null) {
          this.setState({pessoa: response.data.pessoa});
          this.setState({campoPessoaPesquisada: 'block'});
          this.setState({pessoaPesquisada: response.data.pessoa.nome});
        } else {
          this.setState({campoPessoaPesquisada: 'none'});
          this.setState({pessoaPesquisada: ''});
        }
        this.setState({tipo: response.data.tipo});
        this.setState({fase: response.data.fase});
        if(response.data.processo != null) {
          this.setState({processoPesquisadoVisivel: 'block'});
          this.setState({codigoProcesso: response.data.codigoProcesso});
          this.setState({partes: response.data.partes});
          if(response.data.fase != null) {
            this.setState({processoPesquisado: response.data.processo + " - " + response.data.fase});
          } else {
            this.setState({processoPesquisado: response.data.processo});
          }
        } else {
            this.setState({processoPesquisadoVisivel: 'none'});
        }

        console.log('Dados ', response.data);

        if(response.data.tipo == 'A') {
          this.setState({horaAntiga: response.data.hora})
          this.setState({hora: response.data.hora});
        } else {
          this.setState({horaAntiga: null})
          this.setState({hora: ''});
        }

        this.setState({dataLimiteAntiga: response.data.dataLimite});
        var dataLimite = new Date(response.data.dataLimite);
        dataLimite.setDate(dataLimite.getDate() + 1)
        this.setState({dtLimite: new Date(Date.parse(dataLimite))});
        if(response.data.prazoFatal != null) {
          var dataFatal = new Date(response.data.prazoFatal);
          dataFatal.setDate(dataFatal.getDate() + 1)
          this.setState({dtFatal: new Date(Date.parse(dataFatal))});
        } else {
          this.setState({dtFatal: ''});
        }

        this.setState({statusCodigo: response.data.statusCodigo});
        this.setState({status: response.data.statusEntty})
        this.setState({statusAtividade: response.data.status});

        let grau = [];
        if(response.data.importante == 'S') {
          grau.push('importante');
        }

        if(response.data.urgente == 'S') {
          grau.push('urgente');
        }

        if(response.data.privado == 'S') {
          grau.push('privado');
        }
        this.setState({grau: grau});
        //Responsáveis
        this.setState({responsaveisLista: response.data.responsaveisAtividade});
        this.setState({quantidadeResponsaveis: 'Responsaveis da Atividade ( ' + this.state.responsaveisLista.length + ' )'});
        this.setState({responsaveis: response.data.usuariosGrupo});
        //Interessados
        this.setState({interessadosLista: response.data.interessadosAtividade});
        if(response.data.interessadosAtividade != null) {
          this.setState({quantidadeInteressados: 'Atividade sem interessados'});
        } else {
          this.setState({quantidadeInteressados: 'Interessados da Atividade ( ' + this.state.interessadosLista.length + ' )'});
        }
        this.setState({interessados: response.data.usuariosGrupo});
      }).catch(error => {
        console.log('error ', error);
     //   this.setState({openSpinner: false});
       // this.setState(error.response.data)
       // this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
      });

      //Abre modal
      this.abrirModalAtividadeAlterar('modalAtividadeAlterar');
      this.setState({openSpinner: false});
  }

  consultarAtividade = async (atividade) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    this.setState({openSpinner: true});
     await this.atividadeService.consultarAtividade(atividade,usuarioLogado.codigo)
      .then(response => {
        this.setState({atividade: response.data});
        this.setState({codigo: response.data.codigo});
        this.setState({titulo: response.data.titulo});
        this.setState({descricao: response.data.descricao});
        this.setState({usuarioCriouAtividade: response.data.usuario.nome});
        this.setState({dataRegistroAtividade: response.data.dtRegistro});
        this.consultarGrupoTrabalhoPai(response.data.subGrupo.grupoPai);
        this.listarFases();
        this.consultarSubGrupos(response.data.subGrupo.grupoPai);
        this.setState({fase: response.data.fase});
        this.setState({tipo: response.data.tipo});
        this.consultarGruposTrabalho();
        this.setState({selectSubGrupo: response.data.subGrupo});
        if(response.data.processo != null && response.data.processo.codigo != 0) {
          this.consultarProcessoImportancia(response.data.processo.codigo);
          if(response.data.processo.snImportante != null && response.data.processo.snImportante != 'N') {
            this.setState({importanteEmpresa: 'p-button-rounded p-button-warning'});
            this.setState({titileImportanteEmpresa: 'Processo classificado como importante para empresa'});
            this.setState({exibirImportanteEmpresa: 'hide'});
          } else {
            this.setState({importanteEmpresa: 'p-button-rounded p-button-secondary'});
            this.setState({titileImportanteEmpresa: 'Processo normal'});
            this.setState({exibirImportanteEmpresa: 'none'});
          }
          this.setState({partes: response.data.processo.autor});
          this.setState({processo: response.data.processo});
          this.setState({pesquisaProcesso: response.data.processo.nrCnj});
          this.setState({campoPesquisaProcesso: 'none'});
          this.setState({processoPesquisadoVisivel: 'block'});
          if(response.data.processo.nrCnj != '' && response.data.processo.nrCnj != null) {
            var cnjMascarado = response.data.processo.nrCnj.substring(0, 7);
                cnjMascarado = cnjMascarado + "-" + response.data.processo.nrCnj.substring(7, 9);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(9, 13);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(13, 14);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(14, 16);
                cnjMascarado = cnjMascarado + "." + response.data.processo.nrCnj.substring(16, 20);
            this.setState({processoPesquisado: cnjMascarado});
          } else {
            this.setState({processoPesquisado: response.data.processo.nrProcesso});
          }
          this.setState({sizePesquisa: 'col-sm-10'});
          this.setState({escondeBotalExcluirPesquisa: {
            display: 'block'
          }});
          this.setState({bloqueiaGrupo: true});
        } else {
          this.setState({sizePesquisa: 'col-sm-12'});
          this.setState({bloqueiaGrupo: false});
          this.setState({escondeBotalExcluirPesquisa: {
            display: 'none'
          }});
          this.setState({pesquisaProcesso: ''});
          this.setState({processoPesquisadoVisivel: 'none'});
          this.setState({campoPesquisaProcesso: 'block'});
        }

        var data = new Date();
        var mesCompare = String(data.getMonth() + 1).padStart(2, '0');

        var dataLimite = new Date(response.data.dtLimite); 

        //if(mesCompare == dataLimite.getMonth() + 1 && response.data.tipo == 'T') {
          dataLimite.setDate(dataLimite.getDate() + 1);
        //} else {
          //dataLimite.setDate(dataLimite.getDate());
        //}

        this.setState({dtLimite: new Date(Date.parse(dataLimite))});
        this.setState({hora: response.data.hora});
        if(response.data.dtFatal != null) {
          var dataFatal = new Date(response.data.dtFatal);
          //if(mesCompare == dataLimite.getMonth() + 1 && response.data.tipo == 'T') {
            dataFatal.setDate(dataFatal.getDate() + 1);
          //} else {
            //dataFatal.setDate(dataFatal.getDate());
          //s}
          this.setState({dtFatal: new Date(Date.parse(dataFatal))});
        } else {
          this.setState({dtFatal: ''});
        }
        this.setState({selectStatus: response.data.status});
        this.listarArquivosAtividade();

        let grau = [];
        if(response.data.importante == 'S') {
          grau.push('importante');
        }

        if(response.data.urgente == 'S') {
          grau.push('urgente');
        }

        if(response.data.privado == 'S') {
          grau.push('privado');
        }

        if(response.data.pessoa != null) {
          this.setState({pessoa: response.data.pessoa});
          this.setState({campoPessoaPesquisada: 'block'});
          this.setState({pessoaPesquisada: response.data.pessoa.nome});
        } else {
          this.setState({campoPessoaPesquisada: 'none'});
          this.setState({pessoaPesquisada: ''});
        }

        this.setState({grau: grau});
        this.listarExecucaoCheckList(response.data.codigo);
      }
    ).catch(error => {
        console.log(error);
        this.setState({openSpinner: false});
        this.setState(error.response.data)
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
    });

    await this.consultarResponsaveis();
    await this.consultarInteressados();
    this.abrirModalAtividadeAlterar('modalAtividadeAlterar');
    this.setState({openSpinner: false});
  }

  listarExecucaoCheckList = async (atividade) => {
    this.itensCheckList = [];
    this.setState({activeIndex: -1})
    await this.execucaoCheckListService.consultarCheckList(atividade)
      .then(response => {
        this.setState({checkList: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Consulta de Check Lista', detail:`${this.state.detail}`, life: 4000});
      });

      for(let i = 0; i < this.state.checkList.length; i++) {
        if(this.state.checkList[i].status == 'F') {
          this.setState({activeIndex: this.state.checkList[i].checkList.ordem -1});
          break;
        } 
      }

      let item = null;
      for(let i = 0; i < this.state.checkList.length; i++) {
        item = {
          codigo: this.state.checkList[i].codigo,
          checklist: this.state.checkList[i].checkList.codigo,
          status:  this.state.checkList[i].status,
          label: this.state.checkList[i].checkList.tarefa
        }
        this.itensCheckList.push(item);
        this.abrirModal('displayAtividade');
      }
  }

  pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  async onGrupoTrabalhoChange(e) {
    await this.setState({selectGrupo: e.value});
    this.consultarSubGrupos(this.state.selectGrupo.codigo);
    this.listarResponsaveis();
    this.listarInteressados();
  }

  listarResponsaveis = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({responsaveis: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar responśaveis', life: 4000});
      })
  }

  listarInteressados = async() => {
    await this.usuarioGrupoTrabalhoService.listarUsuariosAtividade(this.state.selectGrupo.codigo)
      .then(response => {
        this.setState({interessados: response.data});
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Atividades', detail:'Erro ao listar interssados', life: 4000});
      })
  }

  onSubGrupoChange(e) {
    this.setState({selectSubGrupo: e.value});
  }

  onChangeStatusAtividade(e) {
    this.setState({selectStatus: e.value})
  }

  //Alterar Atividade
  alterarAtividade = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.titulo == '') {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o título da Atividade', life: 4000});
      return false;
    }

    if(this.state.selectGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.selectSubGrupo == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe o Sub-Grupo de Trabalho', life: 4000});
      return false;
    }

    if(this.state.responsaveisLista == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    let tipoTarefa = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '' && this.state.hora != null) {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
        tipoTarefa = 'A';
      } else {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+" 00:00:00";
        tipoTarefa = 'T';
      }
    }

    var dataFormatadaDataFatal = '';
    if(this.state.dtFatal != '' && this.state.dtFatal != null) {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != '' && this.state.hora != null) {
        var dataFormatadaDataFatal =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
      } else {
        var dataFormatadaDataFatal =  year+"-"+month+"-"+day+" 00:00:00";
      }
    }

    var importante = 'N';
    var urgente = 'N';
    var privado = 'N';

    if(this.state.grau != null) {
      for(let i = 0; i < this.state.grau.length; i++) {
        if(this.state.grau[i] == 'importante') {
          importante = 'S';
        }

        if(this.state.grau[i] == 'urgente') {
          urgente = 'S';
        }

        if(this.state.grau[i] == 'privado') {
          privado = 'S';
        }
      }
    }

    const atividadeAlterar = {
      atividade: {
        codigo: this.state.atividade.codigo,
        titulo: this.state.titulo,
        tipo: tipoTarefa,
        descricao: this.state.descricao,
        processo: this.state.processo,
        usuario: usuarioLogado,
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        status: this.state.selectStatus,
        subGrupo: this.state.selectSubGrupo,
        importante: importante,
        urgente: urgente,
        privado: privado,
        pessoa: this.state.pessoa
      },
      responsaveis: this.state.responsaveisLista,
      interessados: this.state.interessadosLista
    }

    var hora = "00:00";
    if(this.state.hora != null) {
      hora = this.state.hora;
    }

    this.setState({openSpinner: true});
    await this.atividadeService.alterarAtividade(this.state.atividade.dtLimite + " " + hora + ":00",
      this.state.atividade.status.codigo, usuarioLogado.codigo,atividadeAlterar)
        .then(response => {
          this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade alterada com sucesso', life: 4000});
          this.listarAgenda();
          this.fecharModalAtividade('modalAtividadeAlterar');
        }).catch(error => {
          this.setState({detail: error.response.data.detail});
          this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 4000});
        });
      
    await this.listarAgenda();
    this.setState({openSpinner: false});
  }

  alterarAtividadeCustom = async () => {
    const usuarioLogado = this.context.usuarioAutenticado;

    if(this.state.responsaveisLista == null || this.state.responsaveisLista.size == 0) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'A atividade precisa de ao menos um responsável', life: 4000});
      return false;
    }

    if(this.state.dtLimite == '' || this.state.dtLimite == null) {
      this.toast.show({severity:'error', summary: 'Atividades', detail:'Informe a Data Limite', life: 4000});
      return false;
    }

    let tipoTarefa = '';
    if(this.state.dtLimite != '' && this.state.dtLimite != null) {
      var date = this.state.dtLimite;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.atividade.tipo == "L") {
        var dataFormatadaDataLimite =  year+"-"+month+"-"+day+" 00:00:00";
        tipoTarefa = 'L';
      } else {
        if(this.state.hora != '' && this.state.hora != null) {
          var dataFormatadaDataLimite =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
          tipoTarefa = 'A';
        } else {
          var dataFormatadaDataLimite =  year+"-"+month+"-"+day+" 00:00:00";
          tipoTarefa = 'T';
        }
      }
    }

    var dataFormatadaDataFatal = "";
    if(this.state.dtFatal != '' && this.state.dtFatal != null) {
      var date = this.state.dtFatal;
      var month = this.pad2(date.getMonth()+1);//months (0-11)
      var day = this.pad2(date.getDate());//day (1-31)
      var year= date.getFullYear();
      if(this.state.hora != null && this.state.hora != '') {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+ " " + this.state.hora + ":00";
      } else {
        dataFormatadaDataFatal =  year+"-"+month+"-"+day+" 00:00:00";
      }
    }

    var importante = 'N';
    var urgente = 'N';
    var privado = 'N';
    if(this.state.grau != null) {
      for(let i = 0; i < this.state.grau.length; i++) {
        if(this.state.grau[i] == 'importante') {
          importante = 'S';
        }

        if(this.state.grau[i] == 'urgente') {
          urgente = 'S';
        }

        if(this.state.grau[i] == 'privado') {
          privado = 'S';
        }
      }
    }

    var processo = null;
    if(this.state.codigoProcesso != null) {
      processo = {
        codigo: this.state.codigoProcesso
      }
    }

    const atividadeAlterar = {
      atividade: {
        codigo: this.state.atividade.codigo,
        titulo: this.state.titulo,
        tipo: tipoTarefa,
        descricao: this.state.descricao,
        usuario: usuarioLogado,
        processo: processo,
        dtLimite: dataFormatadaDataLimite,
        dtFatal: dataFormatadaDataFatal,
        status: this.state.status,
        subGrupo: {
          codigo: this.state.codigoSubGrupo,
          grupoPai: this.state.codigoGrupo
        },
        importante: importante,
        urgente: urgente,
        privado: privado,
        pessoa: this.state.pessoa
      },
      responsaveis: this.state.responsaveisLista,
      interessados: this.state.interessadosLista
    }

    var hora = "00:00";
    if(this.state.horaAntiga != null && this.state.horaAntiga != "") {
      hora = this.state.horaAntiga;
    }

    this.setState({openSpinner: true});
    await this.atividadeService.alterarAtividade(this.state.dataLimiteAntiga + " " + hora + ":00",
      this.state.statusCodigo, usuarioLogado.codigo,atividadeAlterar
      ).then(response => {
        this.toast.show({severity:'success', summary: 'Atividades', detail:'Atividade alterada com sucesso', life: 4000});
      }).catch(error => {
        console.log('Error ', error);
        this.setState(error.response.data);
        this.fecharModalAtividade('displayAtividade');
        this.toast.show({severity:'error', summary: 'Atividades', detail:`${this.state.detail}`, life: 8000});
      });

      await this.listarAgenda();
      this.fecharModalAtividade('modalAtividadeAlterar');
      this.setState({openSpinner: false});
  }

  handleUpload = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processar);
  }

  processar = async (upLoadFile) => {
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('atividade',upLoadFile.file, this.state.atividade.codigo) //Envia código de atividade para salvar os arquivos
    await this.uploadAtividadeService.upload(data)
      .then(response => {
        this.gravarArquivoBanco(upLoadFile.name);
        this.handleDelete(upLoadFile.id);
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  gravarArquivoBanco = async (arquivo) => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.arquivoAtividadeService.salvarArquivo({
      atividade: this.state.atividade,
      arquivo: arquivo,
      descricao: '',
      usuario: usuarioLogado
    }).then(response => {
      this.listarArquivosAtividade();
      this.toast.show({severity:'success', summary: 'Arquivos', detail: `Arquivo ${arquivo} incluído`, life: 4000});
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    })
  }

  handleDelete  = async id => {
    this.setState({upLoadFiles: this.state.upLoadFiles.filter(file => file.id !== id)});
  }

  //Para arquivos anexados em uma nova tarefa
  handleUploadNovaAtividade = async files => {
    const upLoadFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      progress: 0,
      uploaded: false, 
      error: false,
      url: file.url
    }))

    this.setState({
      upLoadFiles: this.state.upLoadFiles.concat(upLoadFiles)
    });

    await upLoadFiles.forEach(this.processarNovaAtividade);
  }

  processarNovaAtividade = async (upLoadFile) => {
    const usuarioLogado = this.context.usuarioAutenticado;
    const data = new FormData();
    data.append('file',upLoadFile.file);
    data.append('usuario',upLoadFile.file, usuarioLogado.codigo) //Envia código de usuário para guardar arquivos
    await this.arquivoAtividadeService.incluirArquivoTemp(data)
      .then(response => {
        this.handleDelete(upLoadFile.id);
        this.listarArquivosTemp();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  listarArquivosTemp = async () => {
    const usuarioLogado = this.context.usuarioAutenticado
    await this.arquivoAtividadeService.listarArquivosTemp(usuarioLogado.codigo)
      .then(response => {
        this.setState({arquivos: response.data});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  acoesArquivos(rowData) {
    return(
      <React.Fragment>
        <Button icon="pi pi-comment" className="p-button-rounded p-button-text"
                tooltip="Adicionar descrição ao arquivo"
                tooltipOptions={{position: 'top'}}
                onClick={() => this.consultarArquivo(rowData)}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-cloud-download" className="p-button-rounded p-button-text"
                tooltip="Baixar Arquivo"
                onClick={() => this.download(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
        &nbsp;
        <Button icon="pi pi-trash" className="p-button-rounded p-button-text"
                tooltip="Excluir Arquivo"
                onClick={() => this.confirmaExclusaoArquivo(rowData)}
                tooltipOptions={{position: 'top'}}
                style={{width: '20px', height: '10px'}}/>
      </React.Fragment>
    );
  }

  async download (rowData){
    this.setState({openSpinner: true});
    await this.consultarArquivoDownload(rowData);
    await this.arquivoAtividadeService.download(rowData.codigo)
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.state.arquivo.arquivo); //or any other extension
        document.body.appendChild(link);
        link.click();
      });
      this.setState({openSpinner: false});
  }

  async consultarArquivoDownload(arquivo){
    await this.arquivoAtividadeService.consultarArquivo(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });
  }

  async consultarArquivo(arquivo){
    await this.arquivoAtividadeService.consultarArquivo(arquivo.codigo)
      .then(response => {
        this.setState({arquivo: response.data});
        this.setState({dsArquivo: response.data.dsArquivo});
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      });

      this.abrirModalDescricaoArquivo('modalDescricaoArquivo');
  }

  abrirModalDescricaoArquivo(name, position) {
    let state = {
        [`${name}`]: true
    };

    if (position) {
        state = {
            ...state,
            position
        }
    }
    this.setState(state);
  }

  excluirArquivo = () => {
    this.arquivoAtividadeService.excluirArquivo(this.state.arquivoCodigo)
      .then(response => {
        this.toast.show({severity:'success', summary: 'Arquivos', detail:'Arquivo excluído com sucesso', life: 4000});
        this.listarArquivosAtividade();
      }).catch(error => {
        this.setState(error.response.data);
        this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
      })
  }

  confirmaExclusaoArquivo(arquivo) {
    this.setState({arquivoCodigo: arquivo.codigo});
    confirmDialog({
        message: 'Deseja realmente excluir este arquivo?',
        header: 'Exclusão de Arquivos',
        icon: 'pi pi-info-circle',
        acceptClassName: 'p-button-danger',
        acceptLabel: 'Sim',
        rejectLabel: 'Não',
        accept: this.acceptExcluirArquivo,
        reject: this.reject
    });
  }

  acceptExcluirArquivo() {
    this.excluirArquivo();
  }

  fecharModalCadastro(name) {
    this.setState({
        [`${name}`]: false
    });
  }

  renderFooterDescricaoArquivo(name) {
    return (
        <div>
           <Button label="Cancelar" 
                    className="p-button-secondary p-button-text"
                    onClick={() => this.fecharModalCadastro(name)}/>
            &nbsp;
            <Button label="Alterar" 
                    className="p-button-primary p-button-text"
                    onClick={this.adicionarDescricao}/> 
      </div>
    );
  }

  adicionarDescricao = () => {
    this.arquivoAtividadeService.adicionarDescricao({
      codigo: this.state.arquivo.codigo,
      dsArquivo: this.state.dsArquivo
    }).then(response => {
      this.toast.show({severity:'success', summary: 'Arquivos', detail:'Descrição adicionada com sucesso', life: 4000});
      this.listarArquivosAtividade();
    }).catch(error => {
      this.setState(error.response.data);
      this.toast.show({severity:'error', summary: 'Arquivos', detail:`${this.state.detail}`, life: 4000});
    });

    this.fecharModalCadastro('modalDescricaoArquivo');
  }

  editarProcessoNaAtividade = () => {
    this.setState({paramProcessoPrincipal: `#/fichaProcesso/${this.state.atividade.processo.codigo}/SEARCH`});
  }

  onMudancaData(e) {
    let selectedCities = [...this.state.mudancaDataHistorico];

    if (e.checked)
        selectedCities.push(e.value);
    else
        selectedCities.splice(selectedCities.indexOf(e.value), 1);

    this.setState({ mudancaDataHistorico: selectedCities });
  }

  templateCoresStatus = (status) => {
    return (
        <>
        &nbsp;
        <Tag style={{padding: '12px'}} className="p-mr-2" style={{backgroundColor: `${status.cor}`}}value={status.status}></Tag>
        </>
    );
  }

  render() {
    const { upLoadFiles } = this.state;

    const usuarioLogado = this.context.usuarioAutenticado;
    const usuarioPerfil = usuarioLogado.perfil.codigo;
    var adm = 'none';
    if(usuarioPerfil == 1) {
      adm = 'hide';
    }
                                          
    var admCoriolanoEdita = '';
    var admCoriolanoNaoEdita = '';
    if(usuarioPerfil == 1) {
      admCoriolanoEdita = 'block';
      admCoriolanoNaoEdita = 'none';
    } else {
      admCoriolanoEdita = 'none';
      admCoriolanoNaoEdita = 'block';
    }

    var tituloPredefinidoSim = 'none';
    var tituloNaoPredefinido = 'block';
    if(usuarioLogado.empresa.tituloPredefinido == 'S') {
     tituloPredefinidoSim = 'block';
     tituloNaoPredefinido = 'none';
    } else {
     tituloPredefinidoSim = 'none';
     tituloNaoPredefinido = 'block';
    }

    var statusFazendo = '';
    var statusCiente = '';
    if(usuarioLogado.empresa.codigo === 138) {
      statusFazendo = 'Iniciado';
      statusCiente = 'Concluído pelo Estagiário';
    } else {
      statusFazendo = 'Fazendo';
      statusCiente = 'Ciente';
    }

    var exibieDataHistorico = 'none';
    if(usuarioLogado.empresa.codigo == 138) {
      exibieDataHistorico = 'block'
    } else {
      exibieDataHistorico = 'none'
    }

    return(
      <>
        <NavBar/>
        <Toast ref={(el) => this.toast = el} />
        <div className="content-wrapper">
          <section className="content-header">
              <div className="container-fluid">
              <div className="row">
                  <div className="col-md-12">
                    <div className="card card-primary card-outline">
                      <div className="card-header">
                        <h3 className="card-title">
                          <i className="fas fa-stream"></i>
                          <span> Agenda de Compromissos</span>
                          <br></br>
                          <br></br>
                          <DataView value={this.state.statusAtividade} itemTemplate={this.templateCoresStatus} layout="grid" />
                       </h3> 
                      </div>
                      <div className="card-body">    
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <MultiSelect inputId="idGrupos" 
                                        value={this.state.gruposLista} 
                                        options={this.state.grupos} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ gruposLista: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                          <MultiSelect inputId="idUsuarios" 
                                       value={this.state.usuariosLista} 
                                       options={this.state.usuarios} 
                                       style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                       onChange={(e) => this.setState({ usuariosLista: e.value })} 
                                       filter showClear filterBy="nome"
                                       optionLabel="nome" />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                          <MultiSelect inputId="idStatus" 
                                       value={this.state.selectStatusConsulta} 
                                       options={this.state.statusAtividade} 
                                       style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                       onChange={(e) => this.setState({ selectStatusConsulta: e.value })} 
                                       filter showClear filterBy="status"
                                       optionLabel="status" />
                          </div>
                        </div>
                        <div className="col-md-2">
                          <div className="form-group">
                          <MultiSelect inputId="idTipos" 
                                       value={this.state.tipoAtividadeConsulta} 
                                       options={this.tiposAtividade} 
                                       style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                       onChange={(e) => this.setState({ tipoAtividadeConsulta: e.value })} 
                                       
                                       optionLabel="nome" />
                          </div>
                        </div>
                        <div className="col-md-1">
                          <div className="form-group">
                          <Button style={{height: '32px'}} type="button" className="p-button-secondary p-button-text p-button-sm" 
                                    onClick={this.listarAgenda}>
                                <i className="pi pi-filter"></i> &nbsp;&nbsp;Filtrar</Button>
                          </div>
                        </div>
                      </div> 
                        <FullCalendar
                                plugins={[dayGridPlugin, interactionPlugin, timegridPlugin]}
                                initialView="dayGridMonth"
                                editable={true}
                                selectable={true}
                                locales={[ptBrLocale]}
                                selectMirror={true}
                                dayMaxEvents={true}
                                events={this.state.agenda}
                                eventClick={this.abrirAtividade}
                                dateClick={this.novaAtividade}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={this.state.openSpinner}>
                    <CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
                  </Backdrop>

                  {/**Nova Atividade */}
                  <Dialog header="Incluir Atividade" autoComplete="nope"
                          visible={this.state.novaAtividade} 
                          footer={this.renderFooterAtividade('novaAtividade')} 
                          onHide={() => this.fecharModalAtividade('novaAtividade')}>
                      <div className="row">
                        <div className={this.state.sizePesquisa}>
                          <div className="form-group" style={{display: `${this.state.campoPesquisaPessoa}`}}>
                            <InputText id="pessoa" style={{width: '100%', height: '32px'}}
                                      type="text"
                                      autoComplete="none"
                                      value={this.state.pessoaPesquisa}
                                      onKeyPress={event => event.key === 'Enter' && this.consultarPessoasPorNomeOuCpf()}
                                      onChange={e => this.setState({pessoaPesquisa: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Incluir Pessoas, Pesquise a pessoas por nome ou cpf"/>
                          </div>
                          <div className="form-group" style={{display: `${this.state.pessoaPesquisadoVisivel}`}}>
                            <strong>Pessoa: {this.state.pessoaPesquisada}</strong>
                            <br />
                            <a onClick={this.excluirPesquisaPessoa} className="linkCadGrupo" style={{cursor: 'pointer'}}>Desvincular Pessoa</a>
                          </div>
                        </div>
                      </div>
                      <div className="row" style={{display: `${tituloPredefinidoSim}`}}>
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Dropdown value={this.state.tituloAtividade} style={{width: '100%', height: '32px'}} 
                                      options={this.state.titulos} style={{width: '100%', height: '32px'}}
                                      optionLabel="tituloExibir" 
                                      filter showClear filterBy="tituloExibir"
                                      onChange={this.onChangeCheckList}
                                      id="tituloAtividade"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Título de Atividade"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className={this.state.sizePesquisa}>
                          <div className="form-group" style={{display: `${this.state.campoPesquisaProcesso}`}}>
                            <InputText id="processo" style={{width: '100%', height: '32px'}}
                                      type="text"
                                      autoComplete="nope"
                                      disabled={this.state.bloqueiaGrupo}
                                      value={this.state.pesquisaProcesso}
                                      onKeyPress={event => event.key === 'Enter' && this.consultarProcessoPorIndice()}
                                      onChange={e => this.setState({pesquisaProcesso: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Incluir Processo, Pesquise o processo por Pessoa, Pasta ou Número"/>
                          </div>
                          <div className="form-group" style={{display: `${this.state.processoPesquisadoVisivel}`}}>
                            <strong>Processo: {this.state.processoPesquisado}</strong>
                            <br />
                            <a onClick={this.excluirPesquisaProcesso} className="linkCadGrupo" style={{cursor: 'pointer'}}>Desvincular Processo</a>
                          </div>
                        </div>
                      </div>
                      
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Dropdown value={this.state.selectGrupo} style={{width: '100%', height: '32px'}} 
                                      options={this.state.grupos}
                                      disabled={this.state.bloqueiaGrupo}
                                      optionLabel="nome" 
                                      filter showClear filterBy="nome"
                                      onChange={this.onGrupoTrabalhoChange}
                                      id="grupoTrabalho"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Grupo de Trabalho"/>
                                      <a style={{display: `${adm}`}} className="linkCadGrupo" href="#">Incluir novo Grupo de Trabalho</a>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Dropdown value={this.state.selectSubGrupo} style={{width: '100%', height: '32px'}} 
                                      options={this.state.subGrupos}
                                      optionLabel="nome" 
                                      emptyMessage=" "
                                      filter showClear filterBy="nome"
                                      onChange={this.onSubGrupoChange}
                                      id="subGrupoTrabalho"
                                      className="p-inputtext-sm p-d-block p-mb-1"
                                      placeholder="Sub-Grupo de Trabalho"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <MultiSelect inputId="multiselect" 
                                        value={this.state.responsavel} 
                                        options={this.state.responsaveis} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ responsavel: e.value })} 
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" 
                                        placeholder="Responsáveis"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <MultiSelect inputId="multiselect" 
                                        value={this.state.interessado} 
                                        options={this.state.interessados} 
                                        style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                        onChange={(e) => this.setState({ interessado: e.value })}  
                                        filter showClear filterBy="nome"
                                        optionLabel="nome" 
                                        placeholder="Interssados"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                          <Dropdown value={this.state.recorrencia} style={{width: '100%', height: '32px'}} 
                                    options={this.recorrencia} style={{width: '100%', height: '32px'}}
                                    optionLabel="nome" 
                                    emptyMessage=" "
                                    filter showClear filterBy="nome"
                                    onChange={(e) => this.setState({ recorrencia: e.value })}  
                                    id="recorrencia"
                                    className="p-inputtext-sm p-d-block p-mb-1"
                                    placeholder="Recorrência ?"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dtLimite} 
                                      onChange={(e) => this.setState({ dtLimite: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Data Limite"/>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                          <InputMask id="hora" style={{width: '100%', height: '32px'}}
                                    type="text"
                                    mask="99:99"
                                    value={this.state.hora}
                                    onChange={e => this.setState({hora: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dtFatal} 
                                      onChange={(e) => this.setState({ dtFatal: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Prazo fatal"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <InputTextarea id="descricao" 
                                          type="text" 
                                          autoComplete="nope"
                                          style={{width: '100%'}} 
                                          value={this.state.descricao}
                                          onChange={e => this.setState({descricao: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          rows={3} cols={30}
                                          placeholder="Descrição da Atividade"/>
                          </div>
                        </div>
                      </div>
                      <br></br>
                      <div className="col-sm-8">
                        <div className="form-group">
                          <label htmlFor="importante">
                            <Checkbox inputId="importante" 
                                      name="importante" 
                                      value="importante"
                                      onChange={this.onGrauChange} 
                                      checked={this.state.grau.indexOf('importante') !== -1} />
                            &nbsp;&nbsp;
                            Importante
                            &nbsp;&nbsp;
                            <Checkbox inputId="urgente" 
                                      name="urgente" 
                                      value="urgente" 
                                      onChange={this.onGrauChange} 
                                      checked={this.state.grau.indexOf('urgente') !== -1} />
                            &nbsp;&nbsp;
                            Urgente
                            &nbsp;&nbsp;
                            <Checkbox inputId="privado" 
                                      name="privado" 
                                      value="privado" 
                                      onChange={this.onGrauChange} 
                                      checked={this.state.grau.indexOf('privado') !== -1} />
                            &nbsp;&nbsp;
                            Privado
                          </label>
                        </div>
                      </div>
                  </Dialog>

                  {/**Pesquisa de Processos */}
                  <Dialog header="Busca de Processo"
                          visible={this.state.displayProcesso} 
                          style={{ width: '60vw' }} 
                          footer={this.renderFooterProcesso('displayProcesso')} 
                          onHide={() => this.fecharModalAtividade('displayProcesso')}>    

                      <DataTable value={this.state.processos}  alwaysShowPaginator responsiveLayout="scroll"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={4} emptyMessage=" "
                                paginatorRight selectionMode="multiple">
                        <Column field="pasta" header="Pasta"></Column>
                        <Column field="nrProcesso" header="Processo Original"></Column>
                        <Column field="nrCnj" header="Numeração Única"></Column>
                        <Column field="autor" header="Autor x Réu" style={{width: '300px'}}></Column>
                        <Column field="grupoTrabalho.nome" header="Grupo Trab."></Column>
                        <Column body={this.acoesProcesso} exportable={false} style={{ minWidth: '8rem' }}header="Ações"></Column>
                      </DataTable>
                  </Dialog>

                  {/**Novo Anexo */}
                  <Dialog header="Anexar Documentos"
                          visible={this.state.novoAnexo} 
                          style={{ width: '40vw' }} 
                          footer={this.renderFooterNovoAnexo('novoAnexo')} 
                          onHide={() => this.fecharModalAtividade('novoAnexo')}>
                    
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">  
                          <div className="container">
                            
                            <Upload onUpload={this.handleUploadNovaAtividade}/>
                            {!!upLoadFiles && (
                              <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                            )}
                          
                          </div>
                        </div>
                      </div>
                    </div>
                    <DataTable value={this.state.arquivos} paginator responsiveLayout="scroll" size="small"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                emptyMessage="Nenhum Arquivo">
                      <Column field="arquivo" header="Arquivo"/>
                      <Column field="descricao" header="Descrição"/>
                      <Column body={this.acoesArquivos} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                    </DataTable> 
                          
                  </Dialog>

                  {/**Alterar Atividade */}
                  <Dialog header={this.templateCriacaoAtividade} autoComplete="nope"
                          visible={this.state.modalAtividadeAlterar} 
                          footer={this.renderFooterAtividadeAlterar('modalAtividadeAlterar')} 
                          onHide={() => this.fecharModalAtividade('modalAtividadeAlterar')}>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <h5><strong style={{color: '#000'}}>{this.state.titulo} - {this.state.pontuacao}</strong></h5>
                          </div>
                        </div>
                      </div>
                      <div>
                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <Steps model={this.itensCheckList} 
                                    onSelect={(e) => this.marcarCheckList(e)}
                                    activeIndex={this.state.activeIndex} 
                                    readOnly={false} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group" style={{display: `${this.state.campoPessoaPesquisada}`}}>
                            <strong>Pessoa:&nbsp;&nbsp;{this.state.pessoaPesquisada}</strong>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group" style={{display: `${this.state.processoPesquisadoVisivel}`}}>
                            <strong>Processo:&nbsp;&nbsp;
                                      <a className="cursor" 
                                        href={this.state.paramProcessoPrincipal}
                                        target="_blank"
                                        onClick={this.editarProcessoNaAtividade}>{this.state.processoPesquisado}</a>
                            <br/>
                            {this.state.partes}
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <InputText id="grupoDescricao" 
                                      type="text" 
                                      disabled
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.grupoTrabalhoDescricao}
                                      onChange={e => this.setState({grupoTrabalhoDescricao: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <InputText id="subgrupoDescricao" 
                                      type="text" 
                                      disabled
                                      style={{width: '100%', height: '32px'}} 
                                      value={this.state.subGrupoTrabalhoDescricao}
                                      onChange={e => this.setState({subGrupoTrabalhoDescricao: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-6">
                          <div className="form-group">
                            <MultiSelect inputId="multiselect" 
                                          value={this.state.responsaveisLista} 
                                          options={this.state.responsaveis} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ responsaveisLista: e.value })} 
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" 
                                          placeholder="Responsáveis"/>
                            <label className="linkCadGrupo">{this.state.quantidadeResponsaveis}</label>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <MultiSelect inputId="multiselect" 
                                          value={this.state.interessadosLista} 
                                          options={this.state.interessados} 
                                          style={{width: '100%', height: '32px', padding_top: '1px'}} 
                                          onChange={(e) => this.setState({ interessadosLista: e.value })}  
                                          filter showClear filterBy="nome"
                                          optionLabel="nome" 
                                          placeholder="Interssados"/>
                            <label className="linkCadGrupo">{this.state.quantidadeInteressados}</label>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-3">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dtLimite} 
                                      onChange={(e) => this.setState({ dtLimite: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Data Limite"/>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <div className="form-group">
                          <InputMask id="hora" style={{width: '100%', height: '32px'}}
                                      type="text"
                                      mask="99:99"
                                      value={this.state.hora}
                                      onChange={e => this.setState({hora: e.target.value})}
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <div className="form-group">
                            <Calendar id="mask" 
                                      value={this.state.dtFatal} 
                                      onChange={(e) => this.setState({ dtFatal: e.value })} 
                                      locale="es"
                                      style={{width: '100%', height: '32px'}} 
                                      dateFormat="dd/mm/yy"
                                      mask="99/99/9999"
                                      placeholder="Prazo fatal"/>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <InputTextarea value={this.state.descricao} style={{width: '100%'}}
                                            id="descricaoE"
                                            onChange={e => this.setState({descricao: e.target.value})}
                                            rows={4} 
                                            cols={60} />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="form-group">
                            <Dropdown value={this.state.status} style={{width: '100%', height: '32px'}} 
                                      options={this.state.statusAtividade} style={{width: '100%', height: '32px'}}
                                      optionLabel="status" 
                                      emptyMessage=" "
                                      filter showClear filterBy="status"
                                      onChange={this.onChangeStatusAtividade}
                                      id="idStatusAtividade"
                                      className="p-inputtext-sm p-d-block p-mb-1"/>
                          </div>
                        </div>
                      </div>
                      <br></br>
                      <div className="col-sm-8">
                        <div className="form-group">
                          <label htmlFor="importante">
                            <Checkbox inputId="importante" 
                                      name="importante" 
                                      value="importante"
                                      onChange={this.onGrauChange} 
                                      checked={this.state.grau.indexOf('importante') !== -1} />
                            &nbsp;&nbsp;
                            Importante
                            &nbsp;&nbsp;
                            <Checkbox inputId="urgente" 
                                      name="urgente" 
                                      value="urgente" 
                                      onChange={this.onGrauChange} 
                                      checked={this.state.grau.indexOf('urgente') !== -1} />
                            &nbsp;&nbsp;
                            Urgente
                            &nbsp;&nbsp;
                            <Checkbox inputId="privado" 
                                      name="privado" 
                                      value="privado" 
                                      onChange={this.onGrauChange} 
                                      checked={this.state.grau.indexOf('privado') !== -1} />
                            &nbsp;&nbsp;
                            Privado
                          </label>
                        </div>
                      </div>
                  </Dialog>
                  {/**Arquivos Anexados */}
                  <Dialog header="Arquivos Anexados"
                          style={{ width: '40vw' }} 
                          visible={this.state.displayArquivosAnexados} 
                          footer={
                            <frameElement>
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('displayArquivosAnexados')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('displayArquivosAnexados')}>
                      
                      <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">  
                              <div className="container">
                                
                                <Upload onUpload={this.handleUpload}/>
                                {!!upLoadFiles && (
                                  <FileList files={upLoadFiles} onDelete={this.handleDelete}/>
                                )}
                              
                              </div>
                            </div>
                          </div>
                        </div>
                        <DataTable value={this.state.arquivos} paginator responsiveLayout="scroll" size="small"
                                    paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                    currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={10}
                                    emptyMessage="Nenhum Arquivo">
                          <Column field="arquivo" header="Arquivo"/>
                          <Column field="dsArquivo" header="Descrição"/>
                          <Column body={this.acoesArquivos} exportable={false} style={{ minWidth: '8rem' }} header="Ações"/>
                        </DataTable> 
                    </Dialog>   
                    {/**Adicionar descrição ao arquivo */}
                    <Dialog header="Descrição do Arquivo"
                            visible={this.state.modalDescricaoArquivo} 
                            style={{ width: '40vw' }} 
                            footer={this.renderFooterDescricaoArquivo('modalDescricaoArquivo')}
                            onHide={() => this.fecharModalCadastro('modalDescricaoArquivo')}>

                        <div className="row">
                          <div className="col-sm-12">
                            <div className="form-group">
                              <label htmlFor="descricaoArquivo">Descrição</label>
                              <InputText id="descricaoArquivo" 
                                    type="text" 
                                    style={{width: '100%', height: '32px'}} 
                                    value={this.state.dsArquivo}
                                    onChange={e => this.setState({dsArquivo: e.target.value})}
                                    className="p-inputtext-sm p-d-block p-mb-1"/>
                            </div>
                          </div>
                        </div>
                  </Dialog>
                  {/**Descrição da Atividade */}
                  <Dialog header="Descrição da Atividade"
                          style={{ width: '50vw' }} 
                          visible={this.state.modalDescricao} 
                          footer={
                            <frameElement>
                              <Button label="Salvar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('modalDescricao')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('modalDescricao')}>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <InputTextarea id="idDescricaoAtividade" 
                                          type="text" 
                                          autoComplete="nope"
                                          style={{width: '100%'}} 
                                          value={this.state.descricao}
                                          onChange={e => this.setState({descricao: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          rows={6} cols={30}/>
                        </div>
                      </div>
                    </div>
                  </Dialog>
                  {/**Histórico de Atividades */}
                  <Dialog header="Histórico da Atividade" autoComplete="nope"
                          style={{ width: '50vw' }} 
                          visible={this.state.modalConsultarHistorico} 
                          footer={
                            <frameElement>
                              <Button label="Incluir" 
                                      className="p-button-primary p-button-text"
                                      onClick={this.novoHistorico}/>
                              &nbsp;
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('modalConsultarHistorico')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('modalConsultarHistorico')}>
                    <DataTable value={this.state.historico}  paginator responsiveLayout="scroll"
                              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              currentPageReportTemplate="Exibindo {first} para {last} de {totalRecords}" rows={5} emptyMessage=" "
                              selectionMode="multiple">
                      <Column body={this.acoesHistoricoUsuario} exportable={false} style={{ minWidth: '4rem' }}></Column>
                      <Column field="dsHistorico" header="Histórico"></Column>
                      <Column field="dtHistorico" header="Data"></Column>
                      <Column field="usuario.nome" header="Usuário"></Column>
                      <Column body={this.acoesHistorico} exportable={false} style={{ minWidth: '4rem' }}></Column>
                    </DataTable>
                  </Dialog>
                  {/**Incluir um novo histórico */}
                  <Dialog header="Incluir Histórico" autoComplete="nope"
                          style={{ width: '40vw' }} 
                          visible={this.state.modalHistorico} 
                          footer={
                            <frameElement>
                              <Button label="Incluir" 
                                      className="p-button-primary p-button-text"
                                      onClick={() => this.incluirHistorico()}/>
                              &nbsp;
                              <Button label="Fechar" 
                                      className="p-button-secondary p-button-text"
                                      onClick={() => this.fecharModalAtividade('modalHistorico')}/>
                            </frameElement>
                            
                          } 
                          onHide={() => this.fecharModalAtividade('modalHistorico')}> 

                    <div className="row" style={{display: `${exibieDataHistorico}`}}>
                      <div className="col-sm-12">
                        <div className="form-group">
                        <Checkbox inputId="mudancaData" 
                                  name="mudancaData" 
                                  value="mudancaData" 
                                  onChange={this.onMudancaData} 
                                  checked={this.state.mudancaDataHistorico.indexOf('mudancaData') !== -1} />
                          &nbsp;
                          Mudança de Data
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="form-group">
                          <InputTextarea id="historico" 
                                          type="text" 
                                          autoComplete="nope"
                                          style={{width: '100%'}} 
                                          value={this.state.dsHistorico}
                                          onChange={e => this.setState({dsHistorico: e.target.value})}
                                          className="p-inputtext-sm p-d-block p-mb-1"
                                          rows={6} cols={30}/>
                  
                        </div>
                      </div>
                    </div>  
                  </Dialog>
                </section>
              </div>
      </>
    )
  }
}
Agenda.contextType = AuthContext;
export default withRouter (Agenda)

